// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/capability_links.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { CapabilityAskedForIn } from "./registry_records_pb";
import { RegistryRef } from "./registry_resolve_pb";
/**
 * @generated from message mono.datagateway.v1.LinkCapabilityToRequirementRequest
 */ export class LinkCapabilityToRequirementRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkCapabilityToRequirementRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkCapabilityToRequirementRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkCapabilityToRequirementRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkCapabilityToRequirementRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capability_id = 2;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: string target_kind = 3;
   */ _define_property(this, "targetKind", ""), /**
   * @generated from field: string rfi_question_id = 4;
   */ _define_property(this, "rfiQuestionId", ""), /**
   * @generated from field: string proposal_project_id = 5;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string proposal_requirement_id = 6;
   */ _define_property(this, "proposalRequirementId", ""), /**
   * at most 500 Unicode characters
   *
   * @generated from field: string note = 7;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkCapabilityToRequirementRequest, "runtime", proto3);
_define_property(LinkCapabilityToRequirementRequest, "typeName", "mono.datagateway.v1.LinkCapabilityToRequirementRequest");
_define_property(LinkCapabilityToRequirementRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rfi_question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "proposal_requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkCapabilityToRequirementResponse
 */ export class LinkCapabilityToRequirementResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkCapabilityToRequirementResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkCapabilityToRequirementResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkCapabilityToRequirementResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkCapabilityToRequirementResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CapabilityRequirementLinkRecord link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkCapabilityToRequirementResponse, "runtime", proto3);
_define_property(LinkCapabilityToRequirementResponse, "typeName", "mono.datagateway.v1.LinkCapabilityToRequirementResponse");
_define_property(LinkCapabilityToRequirementResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CapabilityRequirementLinkRecord
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnlinkCapabilityRequirementRequest
 */ export class UnlinkCapabilityRequirementRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkCapabilityRequirementRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkCapabilityRequirementRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkCapabilityRequirementRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkCapabilityRequirementRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string link_id = 2;
   */ _define_property(this, "linkId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkCapabilityRequirementRequest, "runtime", proto3);
_define_property(UnlinkCapabilityRequirementRequest, "typeName", "mono.datagateway.v1.UnlinkCapabilityRequirementRequest");
_define_property(UnlinkCapabilityRequirementRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnlinkCapabilityRequirementResponse
 */ export class UnlinkCapabilityRequirementResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkCapabilityRequirementResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkCapabilityRequirementResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkCapabilityRequirementResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkCapabilityRequirementResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkCapabilityRequirementResponse, "runtime", proto3);
_define_property(UnlinkCapabilityRequirementResponse, "typeName", "mono.datagateway.v1.UnlinkCapabilityRequirementResponse");
_define_property(UnlinkCapabilityRequirementResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * Exactly one selector: capability_id, rfi_question_id, or the proposal pair.
 *
 * @generated from message mono.datagateway.v1.ListCapabilityRequirementLinksRequest
 */ export class ListCapabilityRequirementLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilityRequirementLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilityRequirementLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilityRequirementLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilityRequirementLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capability_id = 2;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: string rfi_question_id = 3;
   */ _define_property(this, "rfiQuestionId", ""), /**
   * @generated from field: string proposal_project_id = 4;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string proposal_requirement_id = 5;
   */ _define_property(this, "proposalRequirementId", ""), /**
   * @generated from field: bool include_history = 6;
   */ _define_property(this, "includeHistory", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilityRequirementLinksRequest, "runtime", proto3);
_define_property(ListCapabilityRequirementLinksRequest, "typeName", "mono.datagateway.v1.ListCapabilityRequirementLinksRequest");
_define_property(ListCapabilityRequirementLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rfi_question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "proposal_requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "include_history",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CapabilityRequirementLinkRecord
 */ export class CapabilityRequirementLinkRecord extends Message {
    static fromBinary(bytes, options) {
        return new CapabilityRequirementLinkRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapabilityRequirementLinkRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapabilityRequirementLinkRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapabilityRequirementLinkRecord, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capability_id = 2;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: string target_kind = 3;
   */ _define_property(this, "targetKind", ""), /**
   * @generated from field: string rfi_question_id = 4;
   */ _define_property(this, "rfiQuestionId", ""), /**
   * @generated from field: string rfi_response_project_id = 5;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string proposal_project_id = 6;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string proposal_requirement_id = 7;
   */ _define_property(this, "proposalRequirementId", ""), /**
   * @generated from field: string source = 8;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string note = 9;
   */ _define_property(this, "note", ""), /**
   * @generated from field: string linked_by = 10;
   */ _define_property(this, "linkedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp linked_at = 11;
   */ _define_property(this, "linkedAt", void 0), /**
   * @generated from field: string unlinked_by = 12;
   */ _define_property(this, "unlinkedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp unlinked_at = 13;
   */ _define_property(this, "unlinkedAt", void 0), /**
   * @generated from field: mono.datagateway.v1.CapabilityAskedForIn asked_for_in = 14;
   */ _define_property(this, "askedForIn", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapabilityRequirementLinkRecord, "runtime", proto3);
_define_property(CapabilityRequirementLinkRecord, "typeName", "mono.datagateway.v1.CapabilityRequirementLinkRecord");
_define_property(CapabilityRequirementLinkRecord, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rfi_question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "proposal_requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "linked_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "linked_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "unlinked_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "unlinked_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "asked_for_in",
            kind: "message",
            T: CapabilityAskedForIn
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCapabilityRequirementLinksResponse
 */ export class ListCapabilityRequirementLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilityRequirementLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilityRequirementLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilityRequirementLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilityRequirementLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CapabilityRequirementLinkRecord links = 1;
   */ _define_property(this, "links", []), /**
   * @generated from field: bool can_link = 2;
   */ _define_property(this, "canLink", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilityRequirementLinksResponse, "runtime", proto3);
_define_property(ListCapabilityRequirementLinksResponse, "typeName", "mono.datagateway.v1.ListCapabilityRequirementLinksResponse");
_define_property(ListCapabilityRequirementLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: CapabilityRequirementLinkRecord,
            repeated: true
        },
        {
            no: 2,
            name: "can_link",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SearchCapabilityLinkTargetsRequest
 */ export class SearchCapabilityLinkTargetsRequest extends Message {
    static fromBinary(bytes, options) {
        return new SearchCapabilityLinkTargetsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchCapabilityLinkTargetsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchCapabilityLinkTargetsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchCapabilityLinkTargetsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string query = 2;
   */ _define_property(this, "query", ""), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchCapabilityLinkTargetsRequest, "runtime", proto3);
_define_property(SearchCapabilityLinkTargetsRequest, "typeName", "mono.datagateway.v1.SearchCapabilityLinkTargetsRequest");
_define_property(SearchCapabilityLinkTargetsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CapabilityLinkTarget
 */ export class CapabilityLinkTarget extends Message {
    static fromBinary(bytes, options) {
        return new CapabilityLinkTarget().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapabilityLinkTarget().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapabilityLinkTarget().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapabilityLinkTarget, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string target_kind = 1;
   */ _define_property(this, "targetKind", ""), /**
   * @generated from field: string rfi_question_id = 2;
   */ _define_property(this, "rfiQuestionId", ""), /**
   * @generated from field: string proposal_project_id = 3;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string proposal_requirement_id = 4;
   */ _define_property(this, "proposalRequirementId", ""), /**
   * @generated from field: string label = 5;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string context_name = 6;
   */ _define_property(this, "contextName", ""), /**
   * @generated from field: string excerpt = 7;
   */ _define_property(this, "excerpt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapabilityLinkTarget, "runtime", proto3);
_define_property(CapabilityLinkTarget, "typeName", "mono.datagateway.v1.CapabilityLinkTarget");
_define_property(CapabilityLinkTarget, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proposal_requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "context_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "excerpt",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SearchCapabilityLinkTargetsResponse
 */ export class SearchCapabilityLinkTargetsResponse extends Message {
    static fromBinary(bytes, options) {
        return new SearchCapabilityLinkTargetsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchCapabilityLinkTargetsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchCapabilityLinkTargetsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchCapabilityLinkTargetsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CapabilityLinkTarget targets = 1;
   */ _define_property(this, "targets", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchCapabilityLinkTargetsResponse, "runtime", proto3);
_define_property(SearchCapabilityLinkTargetsResponse, "typeName", "mono.datagateway.v1.SearchCapabilityLinkTargetsResponse");
_define_property(SearchCapabilityLinkTargetsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "targets",
            kind: "message",
            T: CapabilityLinkTarget,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AddCapabilityProofRequest
 */ export class AddCapabilityProofRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddCapabilityProofRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCapabilityProofRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCapabilityProofRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCapabilityProofRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capability_id = 2;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: string artifact_id = 3;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string proof_kind = 4;
   */ _define_property(this, "proofKind", ""), /**
   * @generated from field: string program_id = 5;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string registry_contract_id = 6;
   */ _define_property(this, "registryContractId", ""), /**
   * @generated from field: string note = 7;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCapabilityProofRequest, "runtime", proto3);
_define_property(AddCapabilityProofRequest, "typeName", "mono.datagateway.v1.AddCapabilityProofRequest");
_define_property(AddCapabilityProofRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proof_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "registry_contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AddCapabilityProofResponse
 */ export class AddCapabilityProofResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddCapabilityProofResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCapabilityProofResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCapabilityProofResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCapabilityProofResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CapabilityProofView proof = 1;
   */ _define_property(this, "proof", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCapabilityProofResponse, "runtime", proto3);
_define_property(AddCapabilityProofResponse, "typeName", "mono.datagateway.v1.AddCapabilityProofResponse");
_define_property(AddCapabilityProofResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proof",
            kind: "message",
            T: CapabilityProofView
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RemoveCapabilityProofRequest
 */ export class RemoveCapabilityProofRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveCapabilityProofRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveCapabilityProofRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveCapabilityProofRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveCapabilityProofRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveCapabilityProofRequest, "runtime", proto3);
_define_property(RemoveCapabilityProofRequest, "typeName", "mono.datagateway.v1.RemoveCapabilityProofRequest");
_define_property(RemoveCapabilityProofRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RemoveCapabilityProofResponse
 */ export class RemoveCapabilityProofResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveCapabilityProofResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveCapabilityProofResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveCapabilityProofResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveCapabilityProofResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveCapabilityProofResponse, "runtime", proto3);
_define_property(RemoveCapabilityProofResponse, "typeName", "mono.datagateway.v1.RemoveCapabilityProofResponse");
_define_property(RemoveCapabilityProofResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * History retains unlink provenance, subject to current artifact and program visibility.
 *
 * @generated from message mono.datagateway.v1.ListCapabilityProofsRequest
 */ export class ListCapabilityProofsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilityProofsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilityProofsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilityProofsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilityProofsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capability_id = 2;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: bool include_history = 3;
   */ _define_property(this, "includeHistory", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilityProofsRequest, "runtime", proto3);
_define_property(ListCapabilityProofsRequest, "typeName", "mono.datagateway.v1.ListCapabilityProofsRequest");
_define_property(ListCapabilityProofsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_history",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCapabilityProofsResponse
 */ export class ListCapabilityProofsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilityProofsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilityProofsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilityProofsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilityProofsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CapabilityProofView proofs = 1;
   */ _define_property(this, "proofs", []), /**
   * @generated from field: string gap = 2;
   */ _define_property(this, "gap", ""), /**
   * @generated from field: bool can_link = 3;
   */ _define_property(this, "canLink", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilityProofsResponse, "runtime", proto3);
_define_property(ListCapabilityProofsResponse, "typeName", "mono.datagateway.v1.ListCapabilityProofsResponse");
_define_property(ListCapabilityProofsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proofs",
            kind: "message",
            T: CapabilityProofView,
            repeated: true
        },
        {
            no: 2,
            name: "gap",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "can_link",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CapabilityProofView
 */ export class CapabilityProofView extends Message {
    static fromBinary(bytes, options) {
        return new CapabilityProofView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapabilityProofView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapabilityProofView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapabilityProofView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string proof_kind = 4;
   */ _define_property(this, "proofKind", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef program = 5;
   */ _define_property(this, "program", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef contract = 6;
   */ _define_property(this, "contract", void 0), /**
   * @generated from field: bool as_prime = 7;
   */ _define_property(this, "asPrime", false), /**
   * @generated from field: string linked_by_name = 8;
   */ _define_property(this, "linkedByName", ""), /**
   * @generated from field: google.protobuf.Timestamp linked_at = 9;
   */ _define_property(this, "linkedAt", void 0), /**
   * @generated from field: string capability_id = 10;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: string note = 11;
   */ _define_property(this, "note", ""), /**
   * @generated from field: string linked_by = 12;
   */ _define_property(this, "linkedBy", ""), /**
   * @generated from field: string unlinked_by = 13;
   */ _define_property(this, "unlinkedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp unlinked_at = 14;
   */ _define_property(this, "unlinkedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapabilityProofView, "runtime", proto3);
_define_property(CapabilityProofView, "typeName", "mono.datagateway.v1.CapabilityProofView");
_define_property(CapabilityProofView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proof_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "program",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 6,
            name: "contract",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 7,
            name: "as_prime",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "linked_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "linked_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "linked_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "unlinked_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "unlinked_at",
            kind: "message",
            T: Timestamp
        }
    ]));
